export default __webpack_public_path__ + "static/media/IMG_5518 copie.8d7ad684.jpg";